"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("../../geom/Location"));

var _GeometryFactory = _interopRequireDefault(require("../../geom/GeometryFactory"));

var _Position = _interopRequireDefault(require("../../geomgraph/Position"));

var _Polygon = _interopRequireDefault(require("../../geom/Polygon"));

var _MultiPolygon = _interopRequireDefault(require("../../geom/MultiPolygon"));

var _MaximalEdgeRing = _interopRequireDefault(require("../overlay/MaximalEdgeRing"));

var _OverlayNodeFactory = _interopRequireDefault(require("../overlay/OverlayNodeFactory"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

var _PlanarGraph = _interopRequireDefault(require("../../geomgraph/PlanarGraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ConnectedInteriorTester =
/*#__PURE__*/
function () {
  function ConnectedInteriorTester() {
    _classCallCheck(this, ConnectedInteriorTester);

    ConnectedInteriorTester.constructor_.apply(this, arguments);
  }

  _createClass(ConnectedInteriorTester, [{
    key: "visitInteriorRing",
    value: function visitInteriorRing(ring, graph) {
      var pts = ring.getCoordinates();
      var pt0 = pts[0];
      var pt1 = ConnectedInteriorTester.findDifferentPoint(pts, pt0);
      var e = graph.findEdgeInSameDirection(pt0, pt1);
      var de = graph.findEdgeEnd(e);
      var intDe = null;

      if (de.getLabel().getLocation(0, _Position.default.RIGHT) === _Location.default.INTERIOR) {
        intDe = de;
      } else if (de.getSym().getLabel().getLocation(0, _Position.default.RIGHT) === _Location.default.INTERIOR) {
        intDe = de.getSym();
      }

      _Assert.default.isTrue(intDe !== null, "unable to find dirEdge with Interior on RHS");

      this.visitLinkedDirectedEdges(intDe);
    }
  }, {
    key: "visitShellInteriors",
    value: function visitShellInteriors(g, graph) {
      if (g instanceof _Polygon.default) {
        var p = g;
        this.visitInteriorRing(p.getExteriorRing(), graph);
      }

      if (g instanceof _MultiPolygon.default) {
        var mp = g;

        for (var i = 0; i < mp.getNumGeometries(); i++) {
          var p = mp.getGeometryN(i);
          this.visitInteriorRing(p.getExteriorRing(), graph);
        }
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._disconnectedRingcoord;
    }
  }, {
    key: "setInteriorEdgesInResult",
    value: function setInteriorEdgesInResult(graph) {
      for (var it = graph.getEdgeEnds().iterator(); it.hasNext();) {
        var de = it.next();

        if (de.getLabel().getLocation(0, _Position.default.RIGHT) === _Location.default.INTERIOR) {
          de.setInResult(true);
        }
      }
    }
  }, {
    key: "visitLinkedDirectedEdges",
    value: function visitLinkedDirectedEdges(start) {
      var startDe = start;
      var de = start;

      do {
        _Assert.default.isTrue(de !== null, "found null Directed Edge");

        de.setVisited(true);
        de = de.getNext();
      } while (de !== startDe);
    }
  }, {
    key: "buildEdgeRings",
    value: function buildEdgeRings(dirEdges) {
      var edgeRings = new _ArrayList.default();

      for (var it = dirEdges.iterator(); it.hasNext();) {
        var de = it.next();

        if (de.isInResult() && de.getEdgeRing() === null) {
          var er = new _MaximalEdgeRing.default(de, this._geometryFactory);
          er.linkDirectedEdgesForMinimalEdgeRings();
          var minEdgeRings = er.buildMinimalRings();
          edgeRings.addAll(minEdgeRings);
        }
      }

      return edgeRings;
    }
  }, {
    key: "hasUnvisitedShellEdge",
    value: function hasUnvisitedShellEdge(edgeRings) {
      for (var i = 0; i < edgeRings.size(); i++) {
        var er = edgeRings.get(i);
        if (er.isHole()) continue;
        var edges = er.getEdges();
        var de = edges.get(0);
        if (de.getLabel().getLocation(0, _Position.default.RIGHT) !== _Location.default.INTERIOR) continue;

        for (var j = 0; j < edges.size(); j++) {
          de = edges.get(j);

          if (!de.isVisited()) {
            this._disconnectedRingcoord = de.getCoordinate();
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "isInteriorsConnected",
    value: function isInteriorsConnected() {
      var splitEdges = new _ArrayList.default();

      this._geomGraph.computeSplitEdges(splitEdges);

      var graph = new _PlanarGraph.default(new _OverlayNodeFactory.default());
      graph.addEdges(splitEdges);
      this.setInteriorEdgesInResult(graph);
      graph.linkResultDirectedEdges();
      var edgeRings = this.buildEdgeRings(graph.getEdgeEnds());
      this.visitShellInteriors(this._geomGraph.getGeometry(), graph);
      return !this.hasUnvisitedShellEdge(edgeRings);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return ConnectedInteriorTester;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "findDifferentPoint",
    value: function findDifferentPoint(coord, pt) {
      for (var i = 0; i < coord.length; i++) {
        if (!coord[i].equals(pt)) return coord[i];
      }

      return null;
    }
  }]);

  return ConnectedInteriorTester;
}();

exports.default = ConnectedInteriorTester;

ConnectedInteriorTester.constructor_ = function () {
  this._geometryFactory = new _GeometryFactory.default();
  this._geomGraph = null;
  this._disconnectedRingcoord = null;
  var geomGraph = arguments[0];
  this._geomGraph = geomGraph;
};